// getRespiratoryLevel.js

export function getRespiratoryLevel(value, speciesId) {
  if (speciesId === 1) {
    // Dog
    if (value <= 9) return "error";
    if (value >= 10 && value <= 14) return "warning";
    if (value >= 15 && value <= 30) return "success";
    if (value >= 31 && value <= 59) return "warning";
    if (value >= 60) return "error";
  } else if (speciesId === 2) {
    // Cat
    if (value <= 9) return "error";
    if (value >= 10 && value <= 19) return "warning";
    if (value >= 20 && value <= 30) return "success";
    if (value >= 31 && value <= 60) return "warning";
    if (value >= 61) return "error";
  }

  // Default fallback
  return "";
}